import * as React from 'react';
import {WrapRootElement} from './provider';

export const wrapRootElement = ({element}) => {
  return <WrapRootElement element={element} />;
};
